import type { ReactNode } from "react";

import { PageHeader, PageLayout } from "../layout";

type TDashboardSectionLayoutProps = {
  /** Section title */
  title: string;
  /** Optional subtitle/description */
  subtitle?: string;
  /** Main content (typically the scrollable area) */
  children: ReactNode;
};

/**
 * Shared layout wrapper for dashboard sections: PageLayout + PageHeader + scrollable content area.
 * Reduces repetition of the PageLayout + headerBanner + min-h-0 flex-1 overflow-auto pattern.
 */
export function DashboardSectionLayout({ title, subtitle, children }: TDashboardSectionLayoutProps) {
  return (
    <PageLayout>
      <PageHeader
        title={title}
        subtitle={subtitle}
      />
      <div className="min-h-0 flex-1 overflow-auto">{children}</div>
    </PageLayout>
  );
}
